import { render, staticRenderFns } from "./Plazos.vue?vue&type=template&id=88a285e4&scoped=true"
import script from "./Plazos.vue?vue&type=script&lang=js"
export * from "./Plazos.vue?vue&type=script&lang=js"
import style0 from "./Plazos.vue?vue&type=style&index=0&id=88a285e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a285e4",
  null
  
)

export default component.exports